import { CircularProgress, CircularProgressProps } from '@mui/material';

export type ProgressProps = Pick<CircularProgressProps, 'size' | 'color' | 'thickness'>;

export const Progress = ({ size, thickness = 12 }: ProgressProps) => {
  return <CircularProgress size={size} thickness={thickness} />;
};
